

















import { exportBlobFile } from '@/libs/util';
import DictMixin from '@/mixins/dict-mixin';
import PageMixin from '@/mixins/page-mixin';
import SuperviseServices from '@/services/supervise';
import moment from 'moment';
import { mixins } from 'vue-class-component';
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator';
@Component
export default class AlertData extends mixins(DictMixin, PageMixin) {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @Prop() detail!: any;

  columns: any = [];

  @Watch('visible')
  onVisibleChange() {
    if (this.syncVisible) {
      this.page = 1;
      this.getList();
    }
  }

  superSrv = new SuperviseServices();
  dataSource: any = [];
  async getList() {
    this.loading = true;
    let { modelCode, ruleCode, alertCode } = this.detail;
    let params = { modelCode, ruleCode, alertCode };
    let res: any = await this.superSrv.getOriginList({ ...params, page: this.page, limit: this.limit });
    this.columns = [];
    res.title.forEach((obj: any) => {
      Object.keys(obj).forEach((key: string) => this.columns.push({ title: obj[key], dataIndex: key, width: 180 }));
    });
    let list = res.page.list;
    if (this.detail.indicatorInfos?.length > 0) {
      // 指标预警
      this.dataSource = [];
      let ind = list[0];
      ind.forEach((v: any) => {
        // let keys = Object.keys(v);
        // this.columns.push({ title: data.indName, dataIndex: data.indCode, width: 180 });
        this.dataSource.push(v);
      });
    } else {
      // 主题表预警
      this.dataSource = list[0].map((v: any) => JSON.parse(v));
      //   if (this.dataSource.length > 0) {
      //     this.columns = Object.keys(this.dataSource[0]).map((key: string) => ({ title: key, dataIndex: key, width: 180 }));
      //   }
    }
    console.log(this.dataSource);
    this.total = res.page.totalCount;
    this.loading = false;
  }

  get xWidth() {
    return 180 * this.columns.length;
  }

  excelLoading: boolean = false;
  async exportExcel() {
    let { modelCode, ruleCode, alertCode } = this.detail;
    let params = { modelCode, ruleCode, alertCode };
    this.excelLoading = true;
    let data: string = await this.superSrv.downloadOriginExcel(params);
    const timestamp = moment().format('YYYYMMDD_HHmmss');
    exportBlobFile(`预警源数据_${timestamp}.xls`, data);
    this.excelLoading = false;
  }
}
